import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { IDashboardGraph, IDashboardParams } from "../../interface";
import { axiosProperty, throwResponse } from "config/axios";

export const useGetPropertyDashboardJuristic = (
  params?: IDashboardParams
): UseQueryResult<IDashboardGraph[], Error> => {
  return useQuery(
    ["dashboard-property-administrator", "count-increased-per-month", params],
    async () => {
      const res = await axiosProperty.get(
        "/dashboard/administrator/count-increased-per-month",
        {
          params,
        }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};
